module.exports = [{
      plugin: require('../../node_modules/.pnpm/gatsby-plugin-catch-links@5.16.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@8.57.1__react_00b54854564000e35af7d5eb52a78d3b/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/.pnpm/gatsby-plugin-styled-components@6.16.0_babel-plugin-styled-components@1.13.3_styled-com_14ce6435e93524009da3d5c14755e94b/node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@8.57.1__react-dom@18.0.0_react@18.0.0__react@1_56bc48bebc24d97ac3627ad79abff38f/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
